<template>
    <div class="grid-content">
        <div class="grid-item grid-item-full">
            <v-card-number-input
                label="Card Number"
                v-model="form.pan"
                @input="update"
                @guessed-card-type="onCardTypeUpdate"
                :validate="validate.pan"/>
        </div>
        <div class="grid-item field" :class="{'is-error': validate.expMonth.$error || validate.expYear.$error }">
            <label class="field-label stack-xs">Expiration Date</label>
            <div class="grid-fitted grid-unstackable align-items-center">
                <div class="grid-item inline-m">
                    <multiselect
                        :options="expMonths"
                        :show-labels="false"
                        :allow-empty="false"
                        placeholder="Month"
                        v-model="form.expMonth"
                        @input="update"
                        class="card-instrument-expiry-input"/>
                </div>
                <div class="grid-item">
                    <multiselect
                        :options="expYears"
                        :show-labels="false"
                        :allow-empty="false"
                        placeholder="Year"
                        v-model="form.expYear"
                        @input="update"
                        class="card-instrument-expiry-input"/>
                </div>
            </div>
        </div>
        <div class="grid-item">
            <r-input
                label="CVV"
                @input="update"
                :password="true"
                v-model="form.cvv"
                :validate="validate.cvv"/>
        </div>
        <v-custom-fields-manager
            fluid
            :preload-custom-fields="customFields"
            resource-type="payment-cards"
            v-model="form.customFields"/>
    </div>
</template>

<script>
    import {vCardNumberInput} from '@/components/form';
    import Multiselect from 'vue-multiselect';
    import _ from '@/common/helpers';
    import moment from 'moment';
    import vCustomFieldsManager from '@/components/custom-fields/v-custom-fields-manager';

    export default {
        name: 'payment-card-form',
        components: {
            Multiselect,
            vCustomFieldsManager,
            vCardNumberInput,
        },
        props: {
            customFields: Array,
            validate: {
                type: Object,
            },
        },
        data() {
            return {
                form: {
                    pan: null,
                    expYear: null,
                    expMonth: null,
                    cvv: null,
                    customFields: {},
                },
                expMonths: _.range(1).to(12),
                expYears: _.range(moment().year()).plus(10),
            };
        },
        methods: {
            update() {
                this.$emit('input', this.form);
            },

            onCardTypeUpdate({type}) {
                this.$emit('card-type-update', {type});
            },
        },
    };
</script>
